import React from 'react';

const LABELS = ['Muy corta', 'Aceptable', 'Buena'];

/**
 * Medidor informativo: el registro de bikleta-auth sólo exige que la contraseña no esté
 * vacía y el formulario, 8 caracteres. Los tres segmentos empujan a algo mejor sin
 * bloquear el alta.
 */
export const PasswordStrength: React.FC<{ value: string }> = ({ value }) => {
  if (!value) return null;

  const variety = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((pattern) =>
    pattern.test(value)
  ).length;

  const level = value.length < 8 ? 1 : value.length >= 12 && variety >= 3 ? 3 : 2;

  return (
    <>
      <div className="bk-strength" aria-hidden="true">
        {[1, 2, 3].map((segment) => (
          <span
            key={segment}
            className={`bk-strength__seg${
              segment <= level ? ' bk-strength__seg--on' : ''
            }`}
          />
        ))}
      </div>
      <p className="bk-strength__label">{LABELS[level - 1]}</p>
    </>
  );
};
